module.exports = __webpack_public_path__ + "img/20190615104007QQ截图20190612162900.48f67ad0.png";